export type BillingIntent = "integral_now" | "partial_now" | "charge_later" | "undecided";

export const BILLING_INTENT_BADGE_CLASS: Record<BillingIntent, string> = {
  integral_now: "bg-emerald-100 text-emerald-700 hover:bg-emerald-100 hover:text-emerald-700",
  partial_now: "bg-amber-100 text-amber-700 hover:bg-amber-100 hover:text-amber-700",
  charge_later: "bg-sky-100 text-sky-700 hover:bg-sky-100 hover:text-sky-700",
  undecided: "bg-slate-100 text-slate-700 hover:bg-slate-100 hover:text-slate-700",
};

export const BILLING_INTENT_LABELS: Record<BillingIntent, string> = {
  integral_now: "Cobrança Integral",
  partial_now: "Cobrança Parcial",
  charge_later: "Cobrança depois",
  undecided: "Não definido",
};

export const getBillingIntentLabel = (intent?: BillingIntent) =>
  intent ? BILLING_INTENT_LABELS[intent] : BILLING_INTENT_LABELS.undecided;

export const getBillingIntentBadgeConfig = (intent?: BillingIntent) => {
  if (!intent) return null;

  return {
    label: getBillingIntentLabel(intent),
    className: BILLING_INTENT_BADGE_CLASS[intent],
  };
};
